import React from 'react'

export default props => <div>Chargement en cours</div>
